import { SCREEN_TITLES } from '../localisation/strings.en';
import InfoIcon from '@mui/icons-material/Info';
import GavelIcon from '@mui/icons-material/Gavel';
import HelpIcon from '@mui/icons-material/Help';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import {
    LegalComponent,
    HelpComponent,
    CustomersComponent,
    CustomerDetailComponent,
    SiteDetailComponent,
    FilterDetailComponent,
} from '.';

// these pages are assigned to drawer menu
export const PAGES = [
    {
        title: SCREEN_TITLES.CUSTOMERS,
        route: '/customers',
        component: CustomersComponent,
        icon: PeopleAltIcon,
        tooltip: SCREEN_TITLES.CUSTOMERS,
    },    
];

export const settingRoute = []

export const PAGES2 = [
    {
        title: SCREEN_TITLES.LEGAL,
        route: '/Legal',
        component: LegalComponent,
        icon: GavelIcon,
        tooltip: SCREEN_TITLES.LEGAL,
    },
    {
        title: SCREEN_TITLES.HELP,
        route: '/Help',
        component: HelpComponent,
        icon: HelpIcon,
        tooltip: SCREEN_TITLES.HELP,
    },
];
export const PAGES4 = [
    {
        title: SCREEN_TITLES.RELEASE_NOTES,
        route: '/ReleaseNotes',
        component: '',
        icon: InfoIcon,
        tooltip: SCREEN_TITLES.RELEASE_NOTES,
    },
];

export const AppNavigator = [
    {
        title: SCREEN_TITLES.CUSTOMERS,
        route: '/',
        component: CustomersComponent,
        icon: PeopleAltIcon,
    },
    {
        title: SCREEN_TITLES.CUSTOMERS,
        route: '/customers',
        component: CustomersComponent,
        icon: PeopleAltIcon,
    },
    {
        title: SCREEN_TITLES.CUSTOMERS,
        route: '/customers/detail',
        component: CustomerDetailComponent,
        icon: PeopleAltIcon,
    },
    {
        title: 'Site Detail',
        route: '/customers/detail/site',
        component: SiteDetailComponent,
        icon: PeopleAltIcon,
    },
    {
        title: 'Filter Detail',
        route: '/customers/detail/site/filter',
        component: FilterDetailComponent,
        icon: PeopleAltIcon,
    },
    {
        title: SCREEN_TITLES.LEGAL,
        route: '/legal',
        component: LegalComponent,
        icon: GavelIcon,
    },
    {
        title: SCREEN_TITLES.HELP,
        route: '/help',
        component: HelpComponent,
        icon: HelpIcon,
    },
];

type PageTypeProps = {
    title: string;
    route: string;
    component: any;
    icon: any;
};

export const PAGES3: PageTypeProps[] = [];

const DisableFeatureList = process.env.REACT_APP_DISABLED_FEATURE_LIST || '';

function addFeaturePages(pagesArray: PageTypeProps[], obj: PageTypeProps, disabledFeatureName: string): void {
    if (!DisableFeatureList?.includes(disabledFeatureName)) {
        const isSet = pagesArray.some((page: PageTypeProps) => page.title === obj.title);
        if (!isSet) {
            pagesArray.push(obj);
        }
    }
}

//********** Required code for future reference **********
export const getDisabledFeatureList = (): void => {
};
